<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 5.375H10.5195L9.17969 4.14453C8.85156 3.81641 8.41406 3.625 7.94922 3.625H4.75C3.76562 3.625 3 4.41797 3 5.375V14.125C3 15.1094 3.76562 15.875 4.75 15.875H15.25C16.207 15.875 17 15.1094 17 14.125V7.125C17 6.16797 16.207 5.375 15.25 5.375ZM15.6875 14.125C15.6875 14.3711 15.4688 14.5625 15.25 14.5625H4.75C4.50391 14.5625 4.3125 14.3711 4.3125 14.125V5.375C4.3125 5.15625 4.50391 4.9375 4.75 4.9375H7.94922C8.05859 4.9375 8.16797 4.99219 8.25 5.07422L10 6.6875H15.25C15.4688 6.6875 15.6875 6.90625 15.6875 7.125V14.125ZM12.1875 9.96875H10.6562V8.4375C10.6289 8.08203 10.3555 7.78125 10 7.78125C9.61719 7.78125 9.34375 8.08203 9.34375 8.4375V9.96875H7.78516C7.42969 9.96875 7.15625 10.2695 7.15625 10.625C7.15625 11.0078 7.42969 11.2812 7.78516 11.2812H9.31641V12.8125C9.34375 13.1953 9.61719 13.4688 10 13.4688C10.3555 13.4688 10.6289 13.1953 10.6289 12.8398V11.2812H12.1602C12.543 11.2812 12.8438 11.0078 12.8438 10.625C12.8438 10.2695 12.543 9.96875 12.1875 9.96875Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup></script>

<style></style>
